// @core/api/endpoints/project/list_saved_views.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSavedViewsResponse,
} from '../../../types/project';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/project';

/**
 * List saved views
 * Returns all saved views for the project: the caller's private views plus all shared views.
 */
export async function ListSavedViews(
  project_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSavedViewsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/views`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.get<ListSavedViewsResponse>(requestPath, { ...requestOptions, params });
}
